import "./collapsible-escape.js";



// WEBPACK FOOTER //
// ./project/client/src/core/modules/collapsible-escape/index.js